export type ReminderRuleType = 'OFFSET' | 'SPECIFIC_DATE';

export type ReminderOffsetUnit = 'DAYS' | 'HOURS' | 'MINUTES';

/**
 * One reminder slot (up to 5 per Type) on a Transactional Email /
 * MT-Transactional Email Type. Shared between request and response, same
 * as WhatsAppTemplateParamModel. seqOrder is only meaningful on data coming
 * back from the server (used to derive the "reminder{seqOrder}Date" /
 * "reminder{seqOrder}HtmlName" sentinel index field headers) - the server
 * recomputes it from list position on save, so it's harmless to omit on
 * new slots.
 *
 * There is no htmlFileName here - a reminder's HTML works exactly like the
 * main send's htmlName: supplied per-row via the "reminder{seqOrder}HtmlName"
 * index field, resolved against files uploaded for that activity.
 */
export interface ReminderConfigModel {
  id?: string;
  seqOrder?: number;
  ruleType: ReminderRuleType;
  offsetValue?: number;
  offsetUnit?: ReminderOffsetUnit;
  subject?: string;
}
